<div class="profile-period-table__toolbar">
  <p><strong>{{ summaryLead }}</strong>{{ summaryDetail }}</p>
  <button type="button" class="profile-period-table__toggle" [attr.aria-pressed]="showChange" (click)="toggleChange()"><span aria-hidden="true"></span>Year-on-year change</button>
</div>
<div class="profile-period-table__frame">
  <div class="profile-period-table__scroll" role="region" tabindex="0" [attr.aria-label]="regionLabel">
    <table class="profile-period-table__grid">
      <caption class="profile-period-table__sr-only">{{ caption }}</caption>
      <thead>
        <tr>
          <th scope="col" class="profile-period-table__metric">{{ metricHeading }}</th>
          @for (column of columns; track column.key; let first = $first) {
            <th scope="col">
              <span class="profile-period-table__period-end">@if (first) {<span class="profile-period-table__latest">Latest</span>{{ ' ' }}}@if (column.prefix) {<span class="profile-period-table__ye">{{ column.prefix }}</span>}{{ (column.prefix ? ' ' : '') + column.label }}</span>
              @for (detail of column.details || []; track $index) {<small>{{ detail }}</small>}
              @if (column.url) {<a [href]="column.url" target="_blank" rel="noopener noreferrer" [attr.aria-label]="column.urlAriaLabel || null"><i class="fal fa-file-lines" aria-hidden="true"></i> {{ column.urlLabel || 'Source' }}</a>}
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of rows; track row.name) {
          <tr>
            <th scope="row">{{ row.name }}</th>
            @for (cell of row.cells; track $index) {
              <td [class.profile-period-table__negative]="cell.negative" [class.profile-period-table__blank]="isBlank(cell)" [class.profile-period-table__text]="row.type === 'string'">
                <span class="profile-period-table__figure">{{ cell.display }}</span>
                @if (showChange && cell.direction) {
                  <small class="profile-period-table__change" [title]="changeDescription(cell.change, cell.direction)"><i class="fal" [ngClass]="cell.direction === 'up' ? 'fa-arrow-up' : cell.direction === 'down' ? 'fa-arrow-down' : 'fa-equals'" aria-hidden="true"></i><span aria-hidden="true">{{ changeText(cell.change, cell.direction) }}</span><span class="profile-period-table__sr-only">{{ changeDescription(cell.change, cell.direction) }}</span></small>
                }
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
